import {NavigationProp, useNavigation} from '@react-navigation/native';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import AccountBalance from './AccountBalance';
import PageHeader from './PageHeader';
import Wallets from './Wallets';
import DashboardReportCharts from '../ReportCharts/DashboardReportCharts';
import {
  colors,
  spacing,
  shadows,
  borderRadius,
  typography,
} from '../../theme/theme';

import T from '../../Components/T';
const DashboardFO = () => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const [sdate, setSdate] = useState(moment().toDate());
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();

  const handleDateChange = (days: number) => {
    const newDate = moment(sdate).add(days, 'days').toDate();
    setSdate(newDate > moment().toDate() ? moment().toDate() : newDate);
  };

  const hasAdmin = gdata.menu?.some(v => v.mn_link === '/admin/company');

  useEffect(() => {
    if (gdata.menu && gdata.menu.length > 0 && !hasAdmin) {
      if (gdata.menu.some(v => v.mn_link === '/status/status')) {
        navigation.navigate('StatusScreen');
      } else if (
        gdata.menu.some(
          v =>
            v.mn_link === '/transaction/fohousekeeping' ||
            v.mn_link === '/status/hkstatus' ||
            v.mn_link === '/transaction/publiccleaning' ||
            v.mn_link === '/masters/hkpublicplace'
        )
      ) {
        navigation.navigate('HouseKeeping');
      } else if (
        gdata.menu.some(
          v =>
            v.mn_link?.includes('/am') ||
            v.mn_link?.includes('am-') ||
            v.mn_link === '/masters/am-categories' ||
            v.mn_link === '/transaction/am-assets'
        )
      ) {
        navigation.navigate('AssetHome');
      } else if (
        gdata.menu.some(v => v.mn_link === '/transaction/potablelist')
      ) {
        navigation.navigate('Home');
      } else if (gdata.menu.some(v => v.mn_link === '/transaction/stpurchase')) {
        navigation.navigate('Purchase');
      } else if (
        gdata.menu.some(v => v.mn_link === '/transaction/stpurchaseorder')
      ) {
        navigation.navigate('PurchaseOrder');
      } else if (gdata.menu.some(v => v.mn_link === '/transaction/stindent')) {
        navigation.navigate('Indent');
      }
    }
  }, [gdata.menu, hasAdmin, navigation]);

  if (!hasAdmin) {
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: colors.backgroundSecondary}}>
        <Text style={{color: colors.textSecondary}}><T>Redirecting...</T></Text>
      </View>
    );
  }

  const isToday = moment(sdate).isSame(moment(), 'day');

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      keyboardShouldPersistTaps="handled">
      <PageHeader />

      {/* Date Navigation Pill Control */}
      <View style={styles.dateBar}>
        <TouchableOpacity
          onPress={() => handleDateChange(-1)}
          style={styles.dateNavBtn}
          activeOpacity={0.7}>
          <FontAwesome name="chevron-left" size={14} color={colors.accent} />
        </TouchableOpacity>

        <View style={styles.dateLabelContainer}>
          <FontAwesome name="calendar" size={14} color={colors.accent} style={{marginRight: 8}} />
          <Text style={styles.dateText}>
            {moment(sdate).format('DD MMMM YYYY')}
          </Text>
          {isToday && (
            <View style={styles.todayBadge}>
              <Text style={styles.todayBadgeText}><T>Today</T></Text>
            </View>
          )}
        </View>

        <TouchableOpacity
          onPress={() => handleDateChange(1)}
          disabled={moment(sdate).add(1, 'day').toDate() > moment().toDate()}
          style={[
            styles.dateNavBtn,
            moment(sdate).add(1, 'day').toDate() > moment().toDate() && styles.disabledBtn,
          ]}
          activeOpacity={0.7}>
          <FontAwesome
            name="chevron-right"
            size={14}
            color={
              moment(sdate).add(1, 'day').toDate() > moment().toDate()
                ? colors.mediumGray
                : colors.accent
            }
          />
        </TouchableOpacity>
      </View>

      <AccountBalance date={sdate} />
      <Wallets date={sdate} />
      <DashboardReportCharts date={sdate} />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.backgroundSecondary,
  },
  contentContainer: {
    paddingHorizontal: spacing.md,
    paddingBottom: 80,
  },
  dateBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.white,
    borderRadius: borderRadius.full,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    marginVertical: spacing.sm,
    ...shadows.md,
    borderWidth: 1,
    borderColor: colors.borderLight,
  },
  dateNavBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: colors.backgroundSecondary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabledBtn: {
    backgroundColor: colors.backgroundTertiary,
    opacity: 0.5,
  },
  dateLabelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  dateText: {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
  },
  todayBadge: {
    backgroundColor: colors.successLight,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    borderRadius: borderRadius.full,
    marginLeft: spacing.sm,
  },
  todayBadgeText: {
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.bold,
    color: colors.success,
  },
});

export default DashboardFO;
